import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {PdfPreviewComponent} from './pdf-preview.component';
import {ButtonModule} from '../button/button.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        PdfViewerModule,
        ButtonModule,
    ],
    exports: [
        PdfPreviewComponent,
    ],
    declarations: [
        PdfPreviewComponent
    ]
})
export class PdfPreviewModule {
}
